import { createActions } from "redux-actions";

// Define an enum for your action types
export enum ActionTypes {
  GET_ITEMS = "GET_ITEMS",
  GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS",
  GET_ITEMS_FAILURE = "GET_ITEMS_FAILURE",
  GET_ITEMS_IDLE = "GET_ITEMS_IDLE",
  CLEAR_ITEMS = "CLEAR_ITEMS",
  CLEAR_ITEM = "CLEAR_ITEM",

  GET_ITEM = "GET_ITEM",
  GET_ITEM_SUCCESS = "GET_ITEM_SUCCESS",
  GET_ITEM_FAILURE = "GET_ITEM_FAILURE",
  GET_ITEM_IDLE = "GET_ITEM_IDLE",

  ADD_ITEM = "ADD_ITEM",
  ADD_FAVORITE_FOLDER_ITEM = "ADD_FAVORITE_FOLDER_ITEM",
  ADD_FAVORITE_FILTER_ITEM = "ADD_FAVORITE_FILTER_ITEM",
  ADD_ITEM_SUCCESS = "ADD_ITEM_SUCCESS",
  ADD_ITEM_FAILURE = "ADD_ITEM_FAILURE",
  ADD_ITEM_IDLE = "ADD_ITEM_IDLE",

  UPDATE_ITEM = "UPDATE_ITEM",
  UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS",
  UPDATE_ITEM_FAILURE = "UPDATE_ITEM_FAILURE",
  UPDATE_ITEM_IDLE = "UPDATE_ITEM_IDLE",
  UPDATE_OBJ_WITH_NEW_ITEM_SUCCESS = "UPDATE_OBJ_WITH_NEW_ITEM_SUCCESS",

  DELETE_ITEM = "DELETE_ITEM",
  DELETE_FAVORITE_FOLDER_ITEM = "DELETE_FAVORITE_FOLDER_ITEM",
  DELETE_FAVORITE_FILTER_ITEM = "DELETE_FAVORITE_FILTER_ITEM",
  DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS",
  DELETE_ITEM_FAILURE = "DELETE_ITEM_FAILURE",
  DELETE_ITEM_IDLE = "DELETE_ITEM_IDLE",
}

// Use the enum as a generic parameter in createActions function
const { getItems, getItemsSuccess, getItemsFailure, getItemsIdle, clearItems, clearItem } = createActions(
  ActionTypes.GET_ITEMS,
  ActionTypes.GET_ITEMS_SUCCESS,
  ActionTypes.GET_ITEMS_FAILURE,
  ActionTypes.GET_ITEMS_IDLE,
  ActionTypes.CLEAR_ITEMS,
  ActionTypes.CLEAR_ITEM
);

const { getItem, getItemSuccess, getItemFailure, getItemIdle } = createActions(
  ActionTypes.GET_ITEM,
  ActionTypes.GET_ITEM_SUCCESS,
  ActionTypes.GET_ITEM_FAILURE,
  ActionTypes.GET_ITEM_IDLE
);

const { addItem, addFavoriteFolderItem, addFavoriteFilterItem, addItemSuccess, addItemFailure, addItemIdle } =
  createActions(
    ActionTypes.ADD_ITEM,
    ActionTypes.ADD_FAVORITE_FOLDER_ITEM,
    ActionTypes.ADD_FAVORITE_FILTER_ITEM,
    ActionTypes.ADD_ITEM_SUCCESS,
    ActionTypes.ADD_ITEM_FAILURE,
    ActionTypes.ADD_ITEM_IDLE
  );

const { updateItem, updateItemSuccess, updateItemFailure, updateItemIdle, updateObjWithNewItemSuccess } = createActions(
  ActionTypes.UPDATE_ITEM,
  ActionTypes.UPDATE_ITEM_SUCCESS,
  ActionTypes.UPDATE_ITEM_FAILURE,
  ActionTypes.UPDATE_ITEM_IDLE,
  ActionTypes.UPDATE_OBJ_WITH_NEW_ITEM_SUCCESS
);

const {
  deleteItem,
  deleteFavoriteFolderItem,
  deleteFavoriteFilterItem,
  deleteItemSuccess,
  deleteItemFailure,
  deleteItemIdle,
} = createActions(
  ActionTypes.DELETE_ITEM,
  ActionTypes.DELETE_FAVORITE_FOLDER_ITEM,
  ActionTypes.DELETE_FAVORITE_FILTER_ITEM,
  ActionTypes.DELETE_ITEM_SUCCESS,
  ActionTypes.DELETE_ITEM_FAILURE,
  ActionTypes.DELETE_ITEM_IDLE
);

export {
  getItems,
  getItemsSuccess,
  getItemsFailure,
  getItemsIdle,
  addItem,
  addFavoriteFolderItem,
  deleteFavoriteFolderItem,
  addFavoriteFilterItem,
  deleteFavoriteFilterItem,
  addItemSuccess,
  addItemFailure,
  addItemIdle,
  updateItem,
  updateItemSuccess,
  updateItemFailure,
  updateItemIdle,
  updateObjWithNewItemSuccess,
  deleteItem,
  deleteItemSuccess,
  deleteItemFailure,
  deleteItemIdle,
  getItem,
  getItemSuccess,
  getItemFailure,
  getItemIdle,
  clearItems,
  clearItem
};
